"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalJobType = exports.jobStatusToConnectionStatusConversion = exports.ConnectionStatus = exports.ExternalJobStatus = exports.FailureEndingStatuses = exports.SUCCESS_ENDING_STATUS = void 0;
/**
 * Internal job status constant for a successful job after running async request
 */
exports.SUCCESS_ENDING_STATUS = 'success';
/**
 * Internal job status for a failure job after running async request
 */
var FailureEndingStatuses;
(function (FailureEndingStatuses) {
    FailureEndingStatuses["GENERIC"] = "failure";
    FailureEndingStatuses["JOB_INEXISTENT"] = "failure-job-inexistent";
    /**
     * Something about the connection state precludes running a job -- for
     * example, no undeleted tokens found
     */
    FailureEndingStatuses["CONNECTION_STATE"] = "connection-state";
    /**
     * An error caused by failure to parse job IO
     */
    FailureEndingStatuses["PARSE_ERROR"] = "parse-error";
    /**
     * An error related to how we retrieve data cached between temporal activity
     * calls
     */
    FailureEndingStatuses["ACTIVITY_CACHE"] = "activity-cache";
    /**
     * For when we try to perform an operation against a job in an invalid piece
     * of the job lifecycle. For example, starting a job that's already started.
     */
    FailureEndingStatuses["INVALID_JOB_LIFECYCLE"] = "invalid-job-lifecycle";
    FailureEndingStatuses["INVALID_JOB_INPUT_DATA"] = "failure-invalid-job-input-data";
    FailureEndingStatuses["INVALID_JOB_TYPE"] = "failure-invalid-job-type";
    FailureEndingStatuses["GET_ADAPTERS"] = "failure-get-adapters";
    FailureEndingStatuses["ADAPTER_INVOCATION"] = "failure-adapter-data";
    FailureEndingStatuses["ADAPTERS_INVOCATION"] = "failure-all-adapters-data";
    FailureEndingStatuses["INVALID_ADAPTER_DATA"] = "failure-adapter-data-validation";
    FailureEndingStatuses["ADAPTER_AUTH"] = "failure-adapter-auth";
    FailureEndingStatuses["ACCOUNTANT_AUTH"] = "failure-accountant-auth";
    FailureEndingStatuses["API_AUTH"] = "failure-api-auth";
    FailureEndingStatuses["PENDING_FINCH_ACCOUNTANT_SETUP"] = "failure-pending-finch-accountant-setup";
    FailureEndingStatuses["ACCOUNT_EXPIRED"] = "failure-account-expired";
    FailureEndingStatuses["EMPLOYEE_IDS"] = "failure-employee-ids";
    FailureEndingStatuses["S3_UPLOAD"] = "failure-s3-upload";
    FailureEndingStatuses["INITIALIZING_SERVICES"] = "failure-initializing-services";
    FailureEndingStatuses["MANUAL_DESTRUCTION"] = "manual-destruction";
    FailureEndingStatuses["DURATION"] = "failure-job-duration";
    FailureEndingStatuses["RESOURCE_USAGE"] = "failure-resource-usage";
    FailureEndingStatuses["TIMEOUT_HUNG"] = "failure-timeout-hung";
    FailureEndingStatuses["RATELIMITED"] = "failure-ratelimited";
    FailureEndingStatuses["ACCOUNTANT_INSUFFICIENT_PERMISSIONS"] = "failure-accountant-insufficient-permissions";
    FailureEndingStatuses["ACCOUNTANT_REVOKED"] = "failure-accountant-revoked";
    FailureEndingStatuses["AUTHORIZATION_PENDING"] = "failure-authorization-pending";
    FailureEndingStatuses["RESOURCE_NOT_FOUND"] = "failure-resource-not-found";
    /**
     * When job A is marked as failed, job B that depends on job A should
     * automatically be marked as failed as well.
     */
    FailureEndingStatuses["UPSTREAM_JOB_FAILURE"] = "failure-upstream-job";
    /**
     * Authentication error that should not trigger a reauth status update
     * Used for temporary auth failures that don't require reauthorization
     * E.g: 429 Too Many Requests, 415 Unsupported Media Type, 404 Not Found, etc.
     */
    FailureEndingStatuses["UNHANDLED_AUTH_ERROR"] = "failure-unhandled-auth-error";
    /**
     * System is under maintenance and cannot process jobs
     */
    FailureEndingStatuses["MAINTENANCE"] = "failure-maintenance";
})(FailureEndingStatuses || (exports.FailureEndingStatuses = FailureEndingStatuses = {}));
/**
 * Describe job status that is supported by the dashboard
 */
var ExternalJobStatus;
(function (ExternalJobStatus) {
    ExternalJobStatus["PENDING"] = "pending";
    ExternalJobStatus["IN_PROGRESS"] = "in_progress";
    ExternalJobStatus["COMPLETE"] = "complete";
    ExternalJobStatus["REAUTH_ERROR"] = "reauth_error";
    ExternalJobStatus["PERMISSION_ERROR"] = "permission_error";
    ExternalJobStatus["ERROR"] = "error";
    ExternalJobStatus["PARTIAL_ERROR"] = "partial_error";
})(ExternalJobStatus || (exports.ExternalJobStatus = ExternalJobStatus = {}));
/**
 * Describe connection status that is supported by the dashboard
 */
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["CONNECTED"] = "connected";
    ConnectionStatus["REAUTH_ERROR"] = "reauth_error";
    ConnectionStatus["PERMISSION_ERROR"] = "permission_error";
    ConnectionStatus["PENDING"] = "pending";
})(ConnectionStatus || (exports.ConnectionStatus = ConnectionStatus = {}));
/**
 * Describe a conversion from job status to connection status
 */
exports.jobStatusToConnectionStatusConversion = {
    [ExternalJobStatus.COMPLETE]: ConnectionStatus.CONNECTED,
    [ExternalJobStatus.ERROR]: ConnectionStatus.CONNECTED,
    [ExternalJobStatus.PARTIAL_ERROR]: ConnectionStatus.CONNECTED,
    [ExternalJobStatus.IN_PROGRESS]: ConnectionStatus.PENDING,
    [ExternalJobStatus.PENDING]: ConnectionStatus.PENDING,
    [ExternalJobStatus.REAUTH_ERROR]: ConnectionStatus.REAUTH_ERROR,
    [ExternalJobStatus.PERMISSION_ERROR]: ConnectionStatus.PERMISSION_ERROR,
};
/**
 * Job types that are exposed externally to developers
 */
var ExternalJobType;
(function (ExternalJobType) {
    ExternalJobType["ORG_PAYROLL_SYNC"] = "data_sync_all";
    ExternalJobType["W4_FORM_EMPLOYEE_SYNC"] = "w4_form_employee_sync";
    ExternalJobType["BENEFIT_CREATE"] = "benefit_create";
    ExternalJobType["BENEFIT_UPDATE"] = "benefit_update";
    ExternalJobType["BENEFIT_ENROLL"] = "benefit_enroll";
    ExternalJobType["BENEFIT_UNENROLL"] = "benefit_unenroll";
    ExternalJobType["BENEFIT_REGISTER"] = "benefit_register";
})(ExternalJobType || (exports.ExternalJobType = ExternalJobType = {}));
